import Tracker from './tracker'
import ObserverTracker from './observer'
import VueTracker, { PixelTracker, VueObserverTracker } from './vue'

export default Tracker
export { VueTracker, PixelTracker, ObserverTracker, VueObserverTracker }
